import { Users } from "lucide-react";

/**
 * Free-licence availability meter.
 * `taken` is a live count of real applications from the database - if the owner
 * has not configured a slot total, we show nothing rather than invent scarcity.
 */
export const SlotsMeter = ({ availability, testId = "slots-meter", compact = false }) => {
  if (!availability?.total) return null;

  const { total, taken, remaining, percent_claimed: pct } = availability;
  const low = remaining <= Math.max(5, Math.round(total * 0.15));
  const barColor = low ? "var(--gm-red)" : "var(--gm-success)";

  return (
    <div data-testid={testId}>
      <div className="flex items-center justify-between gap-2">
        <span
          className="inline-flex items-center gap-1.5 text-[11px] font-semibold"
          style={{ color: "var(--gm-muted)" }}
        >
          <Users className="h-3.5 w-3.5" aria-hidden="true" />
          {taken} of {total} free licences claimed
        </span>
        <span
          className="font-mono-gm text-[11px] font-bold"
          data-testid={`${testId}-remaining`}
          style={{ color: low ? "#FF8A8E" : "var(--gm-success)" }}
        >
          {remaining} left
        </span>
      </div>

      <div
        className="mt-2 h-1.5 w-full overflow-hidden rounded-full"
        role="progressbar"
        aria-valuenow={pct || 0}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Free licences claimed"
        style={{ background: "rgba(255,255,255,0.1)" }}
      >
        <div
          className="h-full rounded-full"
          style={{
            width: `${Math.max(2, pct || 0)}%`,
            background: barColor,
            transition: "width 400ms cubic-bezier(0.16,1,0.3,1)",
          }}
        />
      </div>

      {!compact && availability.claimed_this_week > 0 ? (
        <p className="mt-2 text-[11px]" data-testid={`${testId}-week`} style={{ color: "var(--gm-muted-2)" }}>
          {availability.claimed_this_week} claimed in the last 7 days
        </p>
      ) : null}
    </div>
  );
};
